import React, { PropsWithChildren } from 'react';
import { Navigate, NavigateProps } from 'react-router-dom';

const AppNavigate: React.FC<PropsWithChildren<NavigateProps>> = ({ children, ...props }) => (
  <Navigate {...props} to={props.to} />
);

export default AppNavigate;
